import React, { useEffect, useState } from 'react';
import Layout from '../components/layout/layout';
import Seo from '../components/seo';
import { graphql } from 'gatsby';
import MastheadWithGrid from '../components/genericFlexible/mastheadWithGrid';
import HalfHalfSection from '../components/genericFlexible/halfHalfSection';
import HalfHalfSectionWithAccordion from '../components/genericFlexible/halfHalfSectionWithAccordion';
import TwoColumnSectionWithOrWithoutTabs from '../components/genericFlexible/twoColumnSectionWithOrWithoutTabs';
import FullWidthReviewSection from '../components/genericFlexible/fullWidthReviewSection';
import FullWidthGenericSection from '../components/genericFlexible/fullWidthGenericSection';
import RelatedResourcesSection from '../components/genericFlexible/relatedResourcesSection';
import GenericGridSection from '../components/genericFlexible/genericGridSection';
import GenericTwoColumnMastheadSectionWithGrid from '../components/genericFlexible/genericTwoColumnMastheadSectionWithGrid';
import GenericTwoColumnMastheadSectionWithoutGrid from '../components/genericFlexible/genericTwoColumnMastheadSectionWithoutGrid';
import FullWidthBannerOrPromoOrStatisticsSection from '../components/genericFlexible/fullWidthBannerOrPromoOrStatisticsSection';
import GenericGridContentOnlySection from '../components/genericFlexible/genericGridContentOnlySection';
import GenericMarqueeSection from '../components/genericFlexible/genericMarqueeSection';
import GenericIntroWithGridOverImageSection from '../components/genericFlexible/genericIntroWithGridOverImageSection';
import GenericFullWidthImageWithImagePatternGridSection from '../components/genericFlexible/genericFullWidthImageWithImagePatternGridSection';
import HalfHalfFixedImageScrollingSection from '../components/genericFlexible/halfHalfFixedImageScrollingSection';
import GreenhouseOpenPositions from '../components/genericFlexible/greenhouseOpenPositions';
import CustomHtmlComponent from '../components/genericFlexible/customHtmlComponent';
import LeadershipComponent from '../components/genericFlexible/leadershipComponent';
import CompanyAnnouncementsComponent from '../components/genericFlexible/companyAnnouncementsComponent';
import ImageGalleryComponent from '../components/genericFlexible/imageGalleryComponent';
import CustomerBusinessGridSection from '../components/genericFlexible/customerBusinessGridSection';
import GridWithCarouselOnMobile from '../components/genericFlexible/gridWithCarouselOnMobile';
import PlainContentField from '../components/genericFlexible/plainContentField';
import MarketoFormFlexiComponent from '../components/genericFlexible/marketoFormFlexiComponent';
import InternalReviewsCarouselSection from '../components/genericFlexible/internalReviewsCarouselSection';
import GenericIntroSectionWithGrid from '../components/genericFlexible/genericIntroSectionWithGrid';
import PerformTicketSectionComponent from '../components/genericFlexible/performTicketSectionComponent';
import RepeaterFieldWithStickyNavigation from '../components/genericFlexible/repeaterFieldWithStickyNavigation';
import TableWithGridSectionComponent from '../components/genericFlexible/tableWithGridSectionComponent';
import FeaturedSpeakersSection from '../components/genericFlexible/featuredSpeakersSection';
import SignupCTASection from '../components/genericFlexible/signupCTASection';
import PostPerformEventIntro from '../components/genericFlexible/postPerformEventIntro';
import PostPerformEventAnnouncement from '../components/genericFlexible/postPerformEventAnnouncement';
import UnsubscribePageComponent from '../components/genericFlexible/unsubscribePageComponent';
import HalfHalfBannerComponent from '../components/genericFlexible/halfHalfBannerComponent';
import CustomerReviewsAutoScroll from '../components/genericFlexible/customerReviewsAutoScroll';
import Perform2023Block from '../components/genericFlexible/perform2023Block';
import QuoteGridSectionComponent from '../components/genericFlexible/quoteGridSectionComponent';
import MarketingIndexComponent from '../components/genericFlexible/marketingIndexComponent';
import MarketingPlanBuilderComponent from '../components/genericFlexible/marketingPlanBuilderComponent';
import SeventyThirtyWithGridComponent from '../components/genericFlexible/seventyThirtyWithGridComponent';
import FullWidthMastheadWithGridComponent from '../components/genericFlexible/fullWidthMastheadWithGridComponent';
import VideoGridSectionComponent from '../components/genericFlexible/videoGridSectionComponent';
import TestimonialGridComponent from '../components/genericFlexible/testimonialGridComponent';
import GenericContentBasedGridComponent from '../components/genericFlexible/genericContentBasedGridComponent';
import GenericTabBasedComponent from '../components/genericFlexible/genericTabBasedComponent';
import MultipleGridSectionsWithCtaComponent from '../components/genericFlexible/multipleGridSectionsWithCtaComponent';
import G2QuoteWrapComponent from '../components/genericFlexible/g2QuoteWrapComponent';
import GenericAwardsBannerComponent from '../components/genericFlexible/genericAwardsBannerComponent';
import GenericCtaBannerWithMultipleLayoutComponent from '../components/genericFlexible/genericCtaBannerWithMultipleLayoutComponent';
import TextComponentWithThumbImagesComponent from '../components/genericFlexible/textComponentWithThumbImagesComponent';
import FullWidthTestimonialModuleComponent from '../components/genericFlexible/fullWidthTestimonialModuleComponent';
import AllRelatedResourcesComponent from '../components/genericFlexible/allRelatedResourcesComponent';
import LogosGalleryComponent from '../components/genericFlexible/logosGalleryComponent';
import FaqAccordionComponent from '../components/genericFlexible/faqAccordionComponent';
import FullWidthTestimonialCarouselComponent from '../components/genericFlexible/fullWidthTestimonialCarouselComponent';
import NextCmoFullBannerSectionComponent from '../components/genericFlexible/nextCmoFullBannerSectionComponent';
import SolutionExchangeComponent from '../components/genericFlexible/solutionExchangeComponent';
import SmileyIconAndContentComponent from '../components/genericFlexible/smileyIconAndContentComponent';
import ProductPageComponent from '../components/genericFlexible/productPageComponent';
import HalfHalfMarketocomponent from '../components/genericFlexible/halfHalfMarketocomponent';
import Ebookcomponent from '../components/genericFlexible/ebookcomponent';
import MetricSectioncomponent from '../components/genericFlexible/metricSectionComponent';
import QuoteCarouselSection from '../components/genericFlexible/quoteCarouselSection';
import FeaturedSolutionsComponent from '../components/genericFlexible/featuredSolutionsComponent';
import GenericMultipleTabBasedComponent from '../components/genericFlexible/genericMultipleTabBasedComponent';
import ProgramNameGenerator from '../components/ProgramNameGenerator';
import CheckBoxTableFormatComponent from '../components/genericFlexible/checkBoxTableFormatComponent';

import AOS from 'aos';
import 'aos/dist/aos.css';

export const query = graphql`
query FlexibleModularQuery($slug: String!) {
    allWordpressPage(filter: {slug: {eq: $slug}}) {
      edges {
        node {
            title
            slug
            plannuhPopup {
              plannuhPopupCheck
            }
            modularFlexibleFields {
                modularFields {
                    __typename
                    ... on WordpressPage_Modularflexiblefields_ModularFields_MastheadSectionWithGrid {
                      layoutSelection
                      mastheadSectionWithGridHeader
                      mastheadSectionWithGridTeaser
                      iconPatterns
                      mastheadSectionWithGridButton {
                        target
                        title
                        url
                      }
                      mastheadSectionWithGridImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      mastheadSectionWithGridImageLink{
                        target
                        title
                        url
                      }
                      mastheadGridThumbImages {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      mastheadSectionWithGridVideo
                      mastheadSectionWithGridLottiefile
                      mastheadSectionWithGridLottiefileLink
                      mastheadGridRepeaterTitle
                      mastheadGridRepeaterCarouselCheck
                      mastheadGridRepeaterBackgroundColor
                      mastheadGridRepeater {
                        iconsOrLogos
                        title
                        teaser
                        icon {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                        logo {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                      }
                      maxWidth
                      backgroundColor
                      textColor
                      overrideClass
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_HalfAndHalfSection {
                      selectLayoutForHalfAndHalf
                      maxWidth
                      backgroundColor
                      halfAndHalfSectionHeader
                      overrideClass
                      halfAndHalfSectionRepeater {
                        subHeader
                        header
                        teaser
                        bulletPoints {
                          bulletTeaser
                          bulletHeader
                          icon {
                            altText
                            gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                            sourceUrl
                          }
                        }
                        link {
                          target
                          title
                          url
                        }
                        customerQuoteCheck
                        customerReviewTeaser
                        customerReviewThumb {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        customerReviewName
                        customerReviewTitle
                        backgroundColorImage
                        layout3Image {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        layout3Video
                        halfSectionWistiaVideo
                        image {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        customEmbed
                        background
                        repeaterContentMainHeader
                        repeaterContentWithBackground {
                          header
                          teaser
                          backgroundColor
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_HalfAndHalfSectionWithAccordion {
                      backgroundColor
                      maxWidth
                      halfAndHalfSectionWithAccordionHeader
                      halfAndHalfSectionWithAccordionTeaser
                      halfAndHalfSectionWithAccordionLayoutSelection
                      halfAndHalfSectionWithAccordionRepeater {
                        header
                        teaser
                        link {
                          target
                          title
                          url
                        }
                        imageBackgroundColor
                        image {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_FullWidthReviewSection {
                        backgroundColor
                        maxWidth
                        textColor
                        fullWidthReviewSectionSectionBackground
                        layoutSelection
                        fullWidthReviewSectionStarRating {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        fullWidthReviewSectionTeaser
                        fullWidthReviewSectionAuthorName
                        fullWidthReviewSectionAuthorTitle
                        fullWidthReviewSectionCustomerStoryLink {
                          target
                          title
                          url
                        }
                        fullWidthReviewSectionAuthorImage {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        fullWidthReviewSectionReviewVideo
                        fullWidthReviewSectionVideoEmbed
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_FullWidthGenericSection {
                        backgroundColor
                        maxWidth
                        overrideClass
                        fullWidthGenericSectionTitle
                        fullWidthGenericSectionTeaser
                        fullWidthGenericSectionLink {
                          target
                          title
                          url
                        }
                        fullWidthGenericSectionImage {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericGridSection {
                      backgroundColor
                      textColor
                      genericGridSectionHeader
                      genericGridSectionTeaser
                      layoutSelectionForAlignment
                      gridRepeaterColumnSelection
                      classOverride
                      genericGridSectionImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      genericGridSectionContentBelowImage
                      genericGridSectionLink {
                        url
                        title
                        target
                      }
                      maxWidth
                      genericGridSectionGridsRepeater {
                        sectionBackground
                        googleMapLongitude
                        googleMapLatitude
                        useGoogleMap
                        icon {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                        header
                        teaser
                        link{
                          url
                          title
                          target
                        }
                        bulletPoints {
                          text
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericTwoColumnMastheadSectionWithGrid {
                      backgroundColor
                      maxWidth
                      textColor
                      overrideClass
                      genericTwoColumnMastheadSectionWithGridHeader
                      genericTwoColumnMastheadSectionWithGridTeaser
                      genericTwoColumnMastheadSectionWithGridButton {
                        target
                        title
                        url
                      }
                      genericTwoColumnMastheadSectionWithGridButtonTwo {
                        target
                        title
                        url
                      }
                      genericTwoColumnMastheadSectionWithGridLogos {
                        logo {
                          altText
                          sourceUrl
                        }
                      }
                      genericTwoColumnMastheadSectionWithGridImageOrVideo
                      genericTwoColumnMastheadSectionWithGridVideo
                      genericTwoColumnMastheadSectionWithGridImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      genericTwoColumnMastheadSectionWithGridImageLink{
                        target
                        title
                        url
                      }
                      genericTwoColumnMastheadSectionWithGridBackground
                      genericTwoColumnMastheadSectionWithGridMarketoForm
                      genericTwoColumnMastheadSectionWithGridMarketoSection {
                        genericTwoColumnFormHeader
                        genericTwoColumnFormTeaser
                        genericTwoColumnFormId
                        genericTwoColumnFormCtaOverride
                        genericTwoColumnFormPdf {
                          altText
                          mediaItemUrl
                        }
                        genericTwoColumnFormSubmitMessage
                        genericTwoColumnFormWistiaVideoId
                        genericTwoColumnFormWistiaVideoIdPlaceholder {
                          altText
                          gatsbyImage
                        }
                      }
                      genericTwoColumnMastheadSectionWithGridLogosHeader
                      genericTwoColumnMastheadSectionWithGridCarouselCheck
                      genericTwoColumnMastheadSectionWithGridRepeater {
                        logo {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                      }
                      genericTwoColumnMastheadSectionWithGridLottie
                      genericTwoColumnMastheadSectionWithGridLottieLink
                      threeColumnUniqueGrid {
                        header
                        teaser
                        link {
                          target
                          title
                          url
                        }
                        imageBackgroundColor
                        image {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_FullWidthBannerOrPromoOrStatisticsSection {
                      backgroundColor
                      maxWidth
                      textColor
                      promoBannerOrStatisticsSection
                      promoBannerBackgroundColor
                      promoBannerHeader
                      promoBannerButton {
                        target
                        title
                        url
                      }
                      statisticsHeader
                      statisticsGridSections {
                        unitNumber
                        unitDetails
                        unitColorRepresentor
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericTwoColumnMastheadWithoutGrid {
                      backgroundColor
                      genericTwoColumnMastheadTitle
                      genericTwoColumnMastheadTeaser
                      genericTwoColumnMastheadButton {
                        target
                        title
                        url
                      }
                      genericTwoColumnMastheadImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      maxWidth
                      textColor
                      overrideClass
                      genericTwoColumnMastheadBulletPoints {
                        text
                      }
                      genericTwoColumnMastheadButtonTwo {
                        target
                        title
                        url
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericGridContentOnlySection {
                      backgroundColor
                      maxWidth
                      genericGridContentOnlySectionSubTitle
                      genericGridContentOnlySectionTitle
                      genericGridContentOnlySectionCta
                      genericGridContentOnlySectionLink {
                        target
                        title
                        url
                      }
                      genericGridContentOnlySectionGridBackgroundColor
                      genericGridContentOnlySectionGridRepeater {
                        title
                        teaser
                        icon{
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                      genericGridContentOnlySectionTeaser
                      selectLayout
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericIntroWithGridOverImageSection {
                      backgroundColor
                      maxWidth
                      genericIntroWithGridOverImageSectionTitle
                      genericIntroWithGridOverImageSectionTeaser
                      genericIntroWithGridOverImageSectionButton {
                        target
                        title
                        url
                      }
                      genericIntroWithGridOverImageSectionGridRepeater {
                        title
                        teaser
                        link {
                          target
                          title
                          url
                        }
                        icon {
                          altText
                          sourceUrl
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                      genericIntroWithGridOverImageImageSectionWithTabs {
                        tabTitle
                        tabTeaser
                        tabLink {
                          url
                          title
                          target
                        }
                        tabImage {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericMarqueeSection {
                      backgroundColor
                      maxWidth
                      genericMarqueeSectionContentOne
                      genericMarqueeSectionContentTwo
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericFullWithImageWithPatternAndGridSection {
                      backgroundColor
                      genericFullWithImageWithPatternAndGridSectionBulletPointers {
                        teaser
                      }
                      genericFullWithImageWithPatternAndGridSectionButton {
                        target
                        title
                        url
                      }
                      genericFullWithImageWithPatternAndGridSectionImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      maxWidth
                      genericFullWithImageWithPatternAndGridSectionBackgroundPattern
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_HalfAndHalfFixedImageScrollingSection {
                      fieldGroupName
                      maxWidth
                      overrideClass
                      fixedHalfHalfRepeater {
                        header
                        teaser
                        textLink {
                          target
                          title
                          url
                        }
                        customerQuoteCheck
                        customerReviewTeaser
                        customerReviewName
                        customerReviewTitle
                        customerReviewThumb {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        fixedHalfHalfRepeaterContentBackground
                        fixedHalfHalfRepeaterPatternCheck
                        fixedHalfHalfRepeaterImageBackground
                        fixedHalfHalfRepeaterImage {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        fixedHalfHalfRepeaterLottieFile
                        fixedHalfHalfRepeaterLottieFileLink
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GreenhouseOpenPositions {
                      backgroundColor
                      maxWidth
                      greenhouseOpenPositionsHeader
                      greenhouseOpenPositionsTeaser
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_CustomHtml {
                      backgroundColor
                      customHtml
                      greenhouseOrGeneral
                      maxWidth
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericLeadershipSection {
                      backgroundColor
                      maxWidth
                      leadershipRepeaterFields {
                        leadershipRepeaterFieldsHeader
                        leadershipRepeaterFieldsTeaser
                        leadershipRepeaterFieldsSections {
                          leaderName
                          leaderTitle
                          leaderThumb {
                            altText
                            gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          }
                          leaderBio
                          leaderLinkedinLink
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_CompanyAnnouncementsSection {
                      backgroundColor
                      maxWidth
                      announcements {
                        ... on WordpressNews {
                          id
                          title
                          excerpt
                          date(formatString: "DD MMM YYYY")
                          slug
                        }
                      }
                      news {
                        ... on WordpressNews {
                          id
                          title
                          excerpt
                          featuredImage {
                            node {
                              altText
                              gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                            }
                          }
                          newsPostFields {
                            inTheNews {
                              inTheNewsLink {
                                target
                                title
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericImageGallery {
                      backgroundColor
                      maxWidth
                      genericImageGalleryHeader
                      genericImageGalleryLink {
                        target
                        title
                        url
                      }
                      genericImageGalleryImages {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_CustomerBusinessGridSection {
                      backgroundColor
                      maxWidth
                      customerBusinessGridSectionTitle
                      customerBusinessGridSectionTeaser
                      customerBusinessGridSectionCustomers {
                        figureHeader
                        figureTeaser
                        content
                        customerSectionBackgroundColor
                        link {
                          target
                          title
                          url
                        }
                        logo {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                      customerBusinessGridSectionLogosHeader
                      customerBusinessGridSectionLogosRepeate {
                        logo {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                      customerBusinessGridSectionLogosRepeatePosition
                      customerBusinessGridSectionCarouselCheck
                      genericTwoColumnMastheadSectionWithGridRepeater {
                        logo {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GridSectionWithCarouselOnMobile {
                      backgroundColor
                      maxWidth
                      gridSectionWithCarouselOnMobileHeader
                      gridSectionWithCarouselOnMobileTeaser
                      gridSectionWithCarouselOnMobileGridSections {
                        gridBackgroundColor
                        header
                        teaser
                        icon {
                          altText
                          sourceUrl
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        link {
                          target
                          title
                          url
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_PlainContentField {
                      backgroundColor
                      maxWidth
                      plainContentFieldHeader
                      plainContentFieldContent
                      overrideClass
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_MarketoFormComponent {
                      backgroundColor
                      maxWidth
                      overrideClass
                      marketoFormComponentHeader
                      marketoFormComponentTeaser
                      marketoFormComponentFormId
                      marketoFormComponentThankYouMessage
                      marketoFormComponentZoominfoScript
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_CustomerReviewsCarouselSection {
                      backgroundColor
                      maxWidth
                      overrideClass
                      customerReviewsCarouselRepeaterItems {
                        image {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        wistiavideoid
                        reviewText
                        reviewerName
                        reviewerTitle
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericIntroSectionWithGrid {
                      backgroundColor
                      maxWidth
                      genericIntroSectionWithGridHeader
                      genericIntroSectionWithGridTeaser
                      genericIntroSectionGridSections {
                        title
                        icon {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                      }
                      genericIntroSectionWithGridPostGridTeaser
                      genericIntroSectionWithGridPostGridButton {
                        target
                        title
                        url
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_PerformTicketSection {
                      backgroundColor
                      maxWidth
                      performTicketSection
                      performTicketSectionTeaser
                      performTicketSectionOffers {
                        enableCheck
                        offerName
                        offerPrice
                        offerTeaser
                        offerLink {
                          target
                          title
                          url
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation {
                      backgroundColor
                      maxWidth
                      overrideClass
                      repeaterFieldSections {
                        repeaterFieldSectionHeader
                        repeaterFieldSectionContent {
                          __typename
                          ... on WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation_repeaterFieldSections_RepeaterFieldSectionContent_RichContent {
                            richContentField
                            overrideClassRichContent
                            backgroundColorRichContent
                          }
                          ... on WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation_repeaterFieldSections_RepeaterFieldSectionContent_ImageContent {
                            imageContentCourtesy
                            imageContentField {
                              altText
                              gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                            }
                          }
                          ... on WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation_repeaterFieldSections_RepeaterFieldSectionContent_QuoteSection {
                            quoteSectionField
                            quoteSectionFieldAuthor
                            quoteSectionFieldLink {
                              target
                              title
                              url
                            }
                          }
                          ... on WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation_repeaterFieldSections_RepeaterFieldSectionContent_ContentGrid {
                            contentGridBackground
                            contentGridRepeater {
                              contentGridRepeaterMainLayout
                              contentGridRepeaterMainHeader
                              contentGridRepeaterMainSections {
                                header
                                teaser
                                icon {
                                  altText
                                  gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                                }
                              }
                            }
                          }
                          ... on WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation_repeaterFieldSections_RepeaterFieldSectionContent_HalfAndHalfSectionWithMarketoForm {
                            fieldGroupName
                            halfAndHalfSectionWithMarketoFormAwardsHeader
                            halfAndHalfSectionWithMarketoFormContent
                            halfAndHalfSectionWithMarketoFormHeader
                            halfAndHalfSectionWithMarketoFormId
                            halfAndHalfSectionWithMarketoFormAwardsLogos {
                              altText
                              gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                            }
                            halfAndHalfSectionWithMarketoFormImage {
                              altText
                              gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                            }
                            halfAndHalfSectionWithMarketoFormLink {
                              target
                              title
                              url
                            }
                            halfAndHalfSectionWithMarketoFormMarketoReport
                            halfAndHalfSectionWithMarketoFormPdf {
                              altText
                              link
                            }
                            halfAndHalfSectionWithMarketoFormRightContent
                          }
                        }
                        repeaterFieldSectionSubHeader
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_TableWithGridSection {
                      backgroundColor
                      maxWidth
                      overrideClass
                      tableWithGridSectionHeader
                      tableWithGridSectionRepeaterField {
                        category
                        titleRepeaterFields {
                          title
                        }
                        columnsRepeaterFields {
                          backgroundColor
                          links {
                            link {
                              target
                              title
                              url
                            }
                          }
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_FeaturedSpeakers {
                      backgroundColor
                      maxWidth
                      featuredSpeakersHeader
                      featuredSpeakersHeaderLink {
                        target
                        title
                        url
                      }
                      featuredSpeakersViewAllSpeakersLink {
                        target
                        title
                        url
                      }
                      featuredSpeakersSections {
                        speakerName
                        speakerTitle
                        linkedinUrl
                        image {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_SignUpCtaSection {
                      backgroundColor
                      maxWidth
                      subTitle
                      header
                      signUpCtaSectionTeaser
                      signUpMarketoFormId
                      ctaTitleOverride
                      signUpMarketoFormThankYouMessage
                      signUpMarketoFormNote
                      pdfDownload {
                        mediaItemUrl
                      }
                      signUpButton {
                        target
                        title
                        url
                      }
                      zoominfoTrackingCode
                      signUpImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_PostPerformEventIntro {
                      postEventIntroHeader
                      postEventIntroContent
                      postEventIntroTeaser
                      postEventIntroFormNumber
                      postEventIntroFormThankYou
                      postEventIntroFormCta
                      postEventIntroFormVideo
                      randomGallery {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        sourceUrl
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_PostEventAnnouncementBlock {
                      postEventAnnouncementTitle
                      postEventAnnouncementTeaser
                      postEventAnnouncementSignUpContent
                      signUpTitle
                      signUpFormId
                      signUpFormThankYouMessage
                      signUpFormCtaOverride
                      postEventAnnouncementVideoId
                      postEventAnnouncementGallery {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_UnsubscribeComponent {
                      backgroundColor
                      maxWidth
                      unsubscribeHeader
                      unsubscribeMarketoForm
                      unsubscribeMarketoFormThankYouMessage
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_HalfAndHalfBannerSection {
                      backgroundColor
                      maxWidth
                      halfAndHalfBannerSectionHeader
                      halfAndHalfBannerSectionTeaser
                      halfAndHalfBannerSectionCtaOne {
                        target
                        title
                        url
                      }
                      halfAndHalfBannerSectionTwo {
                        target
                        title
                        url
                      }
                      halfAndHalfBannerSectionImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_CustomerReviewsAutoScroll {
                      backgroundColor
                      maxWidth
                      customerReviewsAutoScrollTitle
                      customerReviewsAutoScrollRepeaterSections {
                        gridIndividualBackground
                        title
                        teaser
                        authorName
                        authorTitle
                        link {
                          target
                          title
                          url
                        }
                        authorThumb {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                      customerReviewsAutoScrollRepeaterSectionsTwo {
                        gridIndividualBackground
                        title
                        teaser
                        authorName
                        authorTitle
                        link {
                          target
                          title
                          url
                        }
                        authorThumb {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block {
                      backgroundColor
                      maxWidth
                      perform2023FlexiFields {
                        __typename
                        ... on WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23IntroSection {
                          perform23IntroSectionHeader
                          perform23IntroSectionTeaser
                          perform23IntroSectionCta {
                            target
                            title
                            url
                          }
                          perform23IntroSectionLocations {
                            hotelLocation
                            hotelName
                            icon {
                              altText
                              sourceUrl
                            }
                          }
                          perform23IntroSectionBanner
                          perform23IntroSectionImage {
                            altText
                            gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                            sourceUrl
                          }
                        }
                        ... on WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23GridSection {
                          perform23GridSectionHeader
                          perform23GridSectionRepeaterSections {
                            header
                            teaser
                          }
                        }
                        ... on WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23VideoSection {
                          perform23VideoSectionVideoId
                          perform23VideoSectionHeader
                          perform23VideoSectionTeaser
                          perform23VideoSectionHeaderCta {
                            target
                            title
                            url
                          }
                        }
                        ... on WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23EmbedSection {
                          perform23EmbedSectionHeader
                          perform23EmbedSectionScriptToEmbed
                          perform23EmbedSectionCta {
                            target
                            title
                            url
                          }
                        }
                        ... on WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23RegistrationSection {
                          perform23RegistrationSectionHeader
                          perform23RegistrationSectionTeaser
                          perform23RegistrationSectionRepeaterSections {
                            perform23RegistrationSectionLocationHotel
                            perform23RegistrationSectionLocationName
                            perform23RegistrationSectionLocationRegistrationCheck
                            perform23RegistrationSectionLocationRegistrationCta {
                              target
                              title
                              url
                            }
                            perform23RegistrationSectionLocationImage {
                              altText
                              gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                            }
                          }
                        }
                        ... on WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23SpeakersSection {
                          perform23SpeakersSectionHeader
                          perform23SpeakersSectionGrid {
                            speakerName
                            speakerTitle
                            speakerBio
                            speakerFacebookLink
                            speakerLinkedinLink
                            speakerThumb {
                              altText
                              gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                            }
                          }
                          perform23SpeakersSectionButton {
                            target
                            title
                            url
                          }
                        }
                        ... on WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23GallerySection {
                          perform23GallerySectionHeader
                          perform23GallerySectionTeaser
                          perform23GallerySectionImages {
                            altText
                            gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          }
                          perform23GallerySectionButton {
                            target
                            title
                            url
                          }
                        }
                        ... on WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23LogosSection {
                          fieldGroupName
                          perform23Logos {
                            altText
                            gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          }
                        }
                        ... on WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23TicketSection {
                          performTicketSection
                          performTicketSectionTeaser
                          performTicketSectionOffers {
                            enableCheck
                            offerName
                            offerPrice
                            offerTeaser
                            offerLink {
                              target
                              title
                              url
                            }
                          }
                        }
                        ... on WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block_Perform2023FlexiFields_Perform23AgendaSection {
                          perform23AgendaSectionHeader
                          perform23AgendaSectionButton {
                            target
                            title
                            url
                          }
                          perform23AgendaSectionAccordion {
                            day
                            date
                            events {
                              eventName
                            }
                          }
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_QuoteSectionsWithGridLayout {
                      backgroundColor
                      maxWidth
                      overrideClass
                      quoteSectionsWithGridLayoutSections {
                        backgroundColor
                        authorName
                        authorTitle
                        title
                        link {
                          target
                          title
                          url
                        }
                        additionalLink {
                          target
                          title
                          url
                        }
                        logo {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                        thumbImage {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_OperationalMarketingIndexComponent {
                      operationalMarketingIndexComponentHeader
                      operationalMarketingIndexComponentTeaser
                      operationalMarketingIndexComponentAccordion {
                        header
                        headerIcon {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                        objectives {
                          text
                          value
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_MarketingPlanBuilderComponent {
                      marketingPlanBuilderComponentHeader
                      marketingPlanBuilderComponentTeaser
                      marketingPlanBuilderComponentSections {
                        icon {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        header
                        content
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_SeventyThirtySectionWithGridText {
                      backgroundColor
                      maxWidth
                      seventyThirtySectionWithGridTextHeader
                      seventyThirtySectionWithGridTextTeaser
                      seventyThirtySectionWithGridTextImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      seventyThirtySectionWithGridTextGrid {
                        header
                        teaser
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_FullWidthMastheadSectionWithGridText {
                      backgroundColor
                      maxWidth
                      fullWidthMastheadSectionWithGridTextHeader
                      fullWidthMastheadSectionWithGridTextTeaser
                      fullWidthMastheadSectionWithGridTextLink {
                        target
                        title
                        url
                      }
                      fullWidthMastheadSectionWithGridTextImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      fullWidthMastheadSectionWithGridTextGrid {
                        header
                        teaser
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_VideoGridSection {
                      backgroundColor
                      maxWidth
                      videoGridSectionHeader
                      videoGridSectionRepeater {
                        backgroundColor
                        subHeader
                        header
                        link {
                          target
                          title
                          url
                        }
                        videoThumbImage{
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        videoId
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_TestimonialsGridSection {
                      backgroundColor
                      maxWidth
                      testimonialsGridSectionHeader
                      testimonialsGridSectionTeaser
                      testimonialsGridSectionRepeaterSections {
                        backgroundColor
                        logo {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                        header
                        link{
                          target
                          title
                          url
                        }
                        resultsHeader1
                        resultsText1
                        resultsHeader2
                        resultsText2
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericContentBasedGridSection {
                      backgroundColor
                      maxWidth
                      genericContentBasedGridSectionHeader
                      genericContentBasedGridSectionTeaser
                      genericContentBasedGridSectionRepeaterSections {
                        backgroundColor
                        header
                        teaser
                        link {
                          target
                          title
                          url
                        }
                        icon {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericTabBasedSection {
                      backgroundColor
                      maxWidth
                      genericTabBasedSectionHeader
                      genericTabBasedSectionTeaser
                      genericTabBasedSectionTabs {
                        tabName
                        tabHeader
                        tabTeaser
                        tabLink {
                          url
                          title
                          target
                        }
                        tabIcon {
                          altText
                          gatsbyImage
                          sourceUrl
                        }
                        tabGrid {
                          link {
                            target
                            title
                            url
                          }
                          teaser
                        }
                        tabImage {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_MultipleGridSectionsWithCta {
                      backgroundColor
                      maxWidth
                      multipleGridSectionsWithCtaHeader
                      multipleGridSectionsWithCtaTeaser
                      multipleGridSectionsWithCtaLayoutCheck
                      multipleGridSectionsWithCtaGrid {
                        header
                        teaser
                        bulletPoints {
                          text
                        }
                        icon {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                        cta {
                          link {
                            target
                            title
                            url
                          }
                        }
                      }
                      addQuote
                      authorName
                      authorQuote
                      quoteAlignment
                      quoteBackground
                      authorThumb {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_G2QuoteWrap {
                      backgroundColor
                      maxWidth
                      g2QuoteWrapHeader
                      g2QuoteWrapTeaser
                      g2QuoteWrapLink {
                        target
                        title
                        url
                      }
                      g2QuoteWrapImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      g2quotewrapimagemobile {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }                      
                      g2QuoteWrapQuotes {
                        ratingIcon {
                          altText
                          sourceUrl
                        }
                        reviewTitle
                        reviewTeaser
                        reviewAuthor
                        reviewDate
                      }
                      g2QuoteWrapRatingText
                      g2QuoteWrapRatingStarImage {
                        altText
                        sourceUrl
                      }
                      g2QuoteWrapRatingSectionImageBadges {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericAwardsBanner {
                      backgroundColor
                      maxWidth
                      genericAwardsBannerTeaser
                      genericAwardsBannerLink {
                        target
                        title
                        url
                      }
                      genericAwardsBannerHeader
                      genericAwardsBannerImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      genericAwardsBannerBackground
                      overrideClass
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericCtaBannerWithmultipleLayout {
                      backgroundColor
                      genericCtaBannerWithmultipleLayoutHeader
                      genericCtaBannerWithmultipleLayoutTeaser
                      genericCtaBannerWithmultipleLayoutType
                      maxWidth
                      genericCtaBannerWithmultipleLayoutLink {
                        target
                        title
                        url
                      }
                      genericCtaBannerWithmultipleLayoutImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      genericCtaBannerWithmultipleLayoutImageMobile{
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)                 
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_TextComponentWithThumbImages {
                      backgroundColor
                      maxWidth
                      textComponentWithThumbImagesHeader
                      textComponentWithThumbImagesLink {
                        target
                        title
                        url
                      }
                      textComponentWithThumbImagesAuthors {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)    
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_FullWidthTestimonialModule {
                      backgroundColor
                      maxWidth
                      fullWidthTestimonialModuleLogo {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      fullWidthTestimonialModuleTestimonial
                      fullWidthTestimonialModuleAuthorName
                      fullWidthTestimonialModuleAuthorTitle
                      fullWidthTestimonialModuleAuthorThumb {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_AllRelatedResources {
                      backgroundColor
                      maxWidth
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_LogosGallery {
                      backgroundColor
                      maxWidth
                      logosGalleryHeader
                      logosGalleryTeaser
                      logosGalleryCta {
                        target
                        title
                        url
                      }
                      logosGalleryImages {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        sourceUrl
                      }
                      overrideClass
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_FaqAccordionComponent {
                      backgroundColor
                      maxWidth
                      faqAccordionComponentContactBackground
                      faqAccordionComponentTeaser
                      faqAccordionComponentHeader
                      faqAccordionComponentContactHeader
                      faqAccordionComponentContactTeaser
                      faqAccordionComponentContactCta {
                        target
                        title
                        url
                      }
                      faqAccordionSections {
                        title
                        teaser
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_FullWidthTestimonialModuleCarouselNewModule2023 {
                      backgroundColor
                      maxWidth
                      fullWidthTestimonialModuleCarouselHeader
                      fullWidthTestimonialModuleCarouselLink {
                        target
                        title
                        url
                      }
                      fullWidthTestimonialModuleLogoCarousel {
                        fullWidthTestimonialModuleAuthorName
                        fullWidthTestimonialModuleAuthorTitle
                        fullWidthTestimonialModuleTestimonial
                        fullWidthTestimonialModuleLogo {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          sourceUrl
                        }
                        fullWidthTestimonialModuleAuthorThumb {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_NextCmoFullBannerSection {
                      backgroundColor
                      maxWidth
                      nextCmoHeader
                      nextCmoContent {
                        addContent
                      }
                      nextCmoButton {
                        target
                        title
                        url
                      }
                      nextCmoImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_SolutionExchangeModule {
                      backgroundColor
                      maxWidth
                      solutionExchangeGridSections {
                        sectionSubTitle
                        sectionTitle
                        sectionModalContent
                        sectionLogo {
                          altText
                          sourceUrl
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_GenericFiftyFiftySectionWithSmileyIconAndContent {
                      backgroundColor
                      maxWidth
                      smileyIconAndContentMainHeader
                      smileyIcon {
                        altText
                        sourceUrl
                      }
                      smileyIconAndContentRepeaterSections {
                        header
                        content
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_ProductPageFlexibleFields {
                      fieldGroupName
                      __typename
                      productPageFlexibleFields {
                        __typename
                        ... on WordpressPage_Modularflexiblefields_ModularFields_ProductPageFlexibleFields_ProductPageFlexibleFields_ProductMasthead {
                          backgroundColor
                          maxWidth
                          productMastheadHeader
                          productMastheadTeaser
                          productMastheadImage {
                            altText
                            gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          }
                          productMastheadMarketoFormId
                          productMastheadMarketoFormThankYouMessage
                        }
                        ... on WordpressPage_Modularflexiblefields_ModularFields_ProductPageFlexibleFields_ProductPageFlexibleFields_ProductFeaturedUpdates {
                          backgroundColor
                          maxWidth
                          productUpdateType
                          productFeaturedSubHeader
                          productFeaturedVideoSection {
                            productFeaturedVideoSectionHeader
                            productFeaturedVideoSectionTeaser
                            productFeaturedVideoSectionCta {
                              target
                              title
                              url
                            }
                            productFeaturedVideoSectionVideoId
                          }
                          productFeaturedGridSection {
                            webinarCheck
                            productFeaturedGridSectionHeader
                            productFeaturedGridSectionTeaser
                            productFeaturedGridSectionDate
                            productFeaturedGridSectionTime
                            productFeaturedGridSectionLink {
                              target
                              title
                              url
                            }
                            productFeaturedGridSectionImage {
                              altText
                              gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                              sourceUrl
                            }
                            productFeaturedGridSectionVideo
                          }
                        }
                      }
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_HalfAndHalfWithMarketo {
                      backgroundColor
                      maxWidth
                      halfAndHalfWithMarketoSubHeader
                      halfAndHalfWithMarketoHeader
                      halfAndHalfWithMarketoContent
                      halfAndHalfWithMarketoFormHeader
                      halfAndHalfWithMarketoFormTeaser
                      halfAndHalfWithMarketoFormPdf{
                        mediaItemUrl
                      }
                      halfAndHalfWithMarketoFormId
                      halfAndHalfWithMarketoCtaOverride
                      halfAndHalfWithMarketoSubmitMessage
                      halfAndHalfWithMarketoWistiaVideoId
                      halfAndHalfWithMarketoWistiaVideoIdPlaceholder {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      halfAndHalfWithMarketoImage {
                        altText
                        gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                      }
                      overrideClass
                    }
                    ... on WordpressPage_Modularflexiblefields_ModularFields_RelatedResourcesSection {
                        backgroundColor
                        maxWidth
                        fieldGroupName
                        relatedResourcesTitle
                        relatedResourcesSubTitle
                        relatedResourcesRelationslPull {
                          ... on WordpressPost {
                            databaseId
                            nodeType
                            title
                            excerpt
                            featuredImage {
                              node {
                                altText
                                gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                              }
                            }
                            link
                            slug
                          }
                          ... on WordpressResource { 
                            databaseId
                            nodeType
                            title
                            excerpt
                            featuredImage {
                              node {
                                altText
                                gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                              }
                            }
                            whitePapersAndEbooks {
                              resourceType
                              resourceDate
                              podcastUrl
                            }
                            link
                            slug
                          }
                          ... on WordpressNews {
                            databaseId
                            nodeType
                            title
                            excerpt
                            featuredImage {
                              node {
                                altText
                                gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                              }
                            }
                            link
                            slug
                          }
                          ... on WordpressEvent {
                            databaseId
                            nodeType
                            title
                            excerpt
                            featuredImage {
                              node {
                                altText
                                gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                              }
                            }
                            link
                            slug
                          }
                        }
                      }
                      ... on WordpressPage_Modularflexiblefields_ModularFields_EbookComponent {
                        backgroundColor
                        maxWidth
                        ebookComponentTitle
                        ebookComponentContent
                        ebookComponentLink {
                          target
                          title
                          url
                        }
                        ebookComponentInternalSectionBackgroundColor
                        ebookComponentImage {
                          altText
                          gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                        }
                      }
                      ... on WordpressPage_Modularflexiblefields_ModularFields_MetricsSectionComponent {
                        backgroundColor
                        maxWidth
                        metricsSectionSubHeader
                        metricsSectionHeader
                        metricsSectionHeaderLogo{
                          altText
                          sourceUrl
                        }
                        metricsSectionContent
                        layoutSelection
                        metricsSectionRepeaterMetrics {
                          unit
                          text
                          icon{
                            altText
                            sourceUrl
                          }
                        }
                      }
                      ... on WordpressPage_Modularflexiblefields_ModularFields_QuoteCarouselSection {
                        quoteCarouselSectionTitle
                        quoteCarouselSectionTeaser
                        maxWidth
                        backgroundColor
                        quoteCarouselSectionAwardLogos {
                          altText
                          sourceUrl
                        }
                        quoteCarouselSectionReviewsSections {
                          authorName
                          authorTitle
                          authorThumb {
                            altText
                            gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                            sourceUrl
                          }
                          review
                          logo{
                            altText
                            sourceUrl
                          }
                          link{
                            target
                            title
                            url
                          }
                          reviewSectionBackgroundColor
                          wistiaId
                          videoPlayBackgroundImage {
                            altText
                            gatsbyImage(formats: WEBP, width: 1920, placeholder: NONE)
                          }
                        }
                      }
                      ... on WordpressPage_Modularflexiblefields_ModularFields_FeaturedSolutionsComponent {
                        backgroundColor
                        maxWidth
                        featuredSolutionsHeader
                        featuredSolutionsTeaser
                        featuredSolutionsButton {
                          target
                          title
                          url
                        }
                        featuredSolutionsSections {
                          title
                          teaser
                          link {
                            target
                            title
                            url
                          }
                          image {
                            altText
                            gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                          }
                        }
                      }
                      ... on WordpressPage_Modularflexiblefields_ModularFields_CheckboxTableFormatComponent {
                        checkboxTableFormatComponentHeader
                        checkboxTableFormatComponentTeaser
                      }
                      ... on WordpressPage_Modularflexiblefields_ModularFields_GenericMultipleTabBasedComponentLatest2025 {
                        backgroundColor
                        maxWidth
                        overrideClass
                        genericMultipleTabBasedComponentMainHeader
                        genericMultipleTabBasedComponentMainTeaser
                        genericMultipleTabBasedComponentSections {
                          tabHeader
                          tabTeaser
                          tabIcon {
                            altText
                            sourceUrl
                          }
                          contentSubHeader
                          contentHeader
                          tabGenericLink {
                            target
                            title
                            url
                          }
                          contentSectionsRepeater {
                            header
                            teaser
                            image {
                              altText
                              gatsbyImage(placeholder: NONE, formats: WEBP, width: 1920)
                            }
                          }
                        }
                      }
                }
              landingPageCheck
              pagesClassOverride
            }
            seo {
              opengraphTitle
              opengraphDescription
              metaKeywords
              metaDesc
              opengraphAuthor
              title
              focuskw
              opengraphImage {
                altText
                sourceUrl
              }
              readingTime
              twitterTitle
              twitterDescription
              twitterImage {
                altText
                sourceUrl
                author {
                  node {
                    name
                  }
                }
              }
            }
        }
      }
    }
  }
`

const Page = ({ data }) => {
  const graphData = data.allWordpressPage.edges[0].node;
  const [careerListCheck, setCareerListCheck] = useState(null);

  setTimeout(() => {
    if (graphData) {
      if (graphData.slug === 'careers-list') {
        if (typeof window !== "undefined") {
          if (window.location.href === 'https://planful.com/jobs/careers-list/' || window.location.href === 'https://gatsbydeploy.planful.com/jobs/careers-list/') {
            setCareerListCheck('l-nodefaultJobPortal');
          }
          else {
            setCareerListCheck('l-defaultJobPortal');
          }
        }
      }
    }
  }, 1000);

  setTimeout(() => {
    if (graphData) {
      if (graphData.slug === 'register') {
        if (typeof document !== 'undefined') {
          if (document.querySelector('#drift-frame-controller')) {
            document.querySelector('#drift-frame-controller').style.display = 'none';
          }
        }
      }
    }
  }, 10000);

  useEffect(() => {
    AOS.init({
      duration: 750, // values from 0 to 3000, with step 50ms
      easing: 'ease-out-cubic', // default easing for AOS animations
      once: true,
    });
  }, []);

  return (
    <Layout pageClassOverride={graphData.modularFlexibleFields.pagesClassOverride ? graphData.modularFlexibleFields.pagesClassOverride : "l-noPageClass"} templateCheck={graphData.modularFlexibleFields.landingPageCheck} graphData={graphData} signup="signup" footerBannerCheck="yes">
      {data.allWordpressPage.edges.map((indItem, index) => (
        <Seo graphData={graphData} data={indItem.node} langs={process.env.GATSBY_LANG ? process.env.GATSBY_LANG : "EN"} key={index} />
      ))}
      {graphData.modularFlexibleFields.pagesClassOverride && graphData.modularFlexibleFields.pagesClassOverride === 'l--webtool' &&
        <ProgramNameGenerator /> 
      }
      {graphData.modularFlexibleFields.modularFields &&
        <div className={`cp-flexible cp-wrapper l-languageCheck${process.env.GATSBY_LANG ? process.env.GATSBY_LANG : "en"} ${graphData ? graphData.slug : ""} ${careerListCheck ? careerListCheck : ""} ${graphData.modularFlexibleFields.pagesClassOverride ? graphData.modularFlexibleFields.pagesClassOverride : ""}`}>
          <div className="cp-flexible__inner">
            {graphData.modularFlexibleFields.modularFields.map((modularItem, index) => (
              <React.Fragment key={index}>
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_MastheadSectionWithGrid' &&
                  <MastheadWithGrid data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HalfAndHalfSection' &&
                  <HalfHalfSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HalfAndHalfSectionWithAccordion' &&
                  <HalfHalfSectionWithAccordion data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {/* {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_TwoColumnSectionWithOrWithoutTabs' &&
                  <TwoColumnSectionWithOrWithoutTabs data={modularItem} />
                } */}
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FullWidthReviewSection' &&
                  <FullWidthReviewSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FullWidthGenericSection' &&
                  <FullWidthGenericSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_RelatedResourcesSection' &&
                  <RelatedResourcesSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericGridSection' &&
                  <GenericGridSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericTwoColumnMastheadSectionWithGrid' &&
                  <GenericTwoColumnMastheadSectionWithGrid data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericTwoColumnMastheadWithoutGrid' &&
                  <GenericTwoColumnMastheadSectionWithoutGrid data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FullWidthBannerOrPromoOrStatisticsSection' &&
                  <FullWidthBannerOrPromoOrStatisticsSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericGridContentOnlySection' &&
                  <GenericGridContentOnlySection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericIntroWithGridOverImageSection' &&
                  <GenericIntroWithGridOverImageSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericMarqueeSection' &&
                  <GenericMarqueeSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericFullWithImageWithPatternAndGridSection' &&
                  <GenericFullWidthImageWithImagePatternGridSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HalfAndHalfFixedImageScrollingSection' &&
                  <HalfHalfFixedImageScrollingSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GreenhouseOpenPositions' &&
                  <GreenhouseOpenPositions data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_CustomHtml' &&
                  <CustomHtmlComponent data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericLeadershipSection' &&
                  <LeadershipComponent data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_CompanyAnnouncementsSection' &&
                  <CompanyAnnouncementsComponent data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericImageGallery' &&
                  <ImageGalleryComponent data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_CustomerBusinessGridSection' &&
                  <CustomerBusinessGridSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GridSectionWithCarouselOnMobile' &&
                  <GridWithCarouselOnMobile data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_PlainContentField' &&
                  <PlainContentField data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_MarketoFormComponent' &&
                  <MarketoFormFlexiComponent data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_CustomerReviewsCarouselSection' &&
                  <InternalReviewsCarouselSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericIntroSectionWithGrid' &&
                  <GenericIntroSectionWithGrid data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_PerformTicketSection' &&
                  <PerformTicketSectionComponent data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation' &&
                  <RepeaterFieldWithStickyNavigation data={modularItem} formId="3176" ctaOverride="" />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_TableWithGridSection' &&
                  <TableWithGridSectionComponent data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FeaturedSpeakers' &&
                  <FeaturedSpeakersSection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_SignUpCtaSection' &&
                  <SignupCTASection data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_PostPerformEventIntro' &&
                  <PostPerformEventIntro data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_PostEventAnnouncementBlock' &&
                  <PostPerformEventAnnouncement data={modularItem} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_UnsubscribeComponent' &&
                  <UnsubscribePageComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HalfAndHalfBannerSection' &&
                  <HalfHalfBannerComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_CustomerReviewsAutoScroll' &&
                  <CustomerReviewsAutoScroll data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_Perform2023Block' &&
                  <Perform2023Block data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_QuoteSectionsWithGridLayout' &&
                  <QuoteGridSectionComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_OperationalMarketingIndexComponent' &&
                  <MarketingIndexComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_MarketingPlanBuilderComponent' &&
                  <MarketingPlanBuilderComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_SeventyThirtySectionWithGridText' &&
                  <SeventyThirtyWithGridComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FullWidthMastheadSectionWithGridText' &&
                  <FullWidthMastheadWithGridComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_VideoGridSection' &&
                  <VideoGridSectionComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_TestimonialsGridSection' &&
                  <TestimonialGridComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericContentBasedGridSection' &&
                  <GenericContentBasedGridComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericTabBasedSection' &&
                  <GenericTabBasedComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_MultipleGridSectionsWithCta' &&
                  <MultipleGridSectionsWithCtaComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_G2QuoteWrap' &&
                  <G2QuoteWrapComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericAwardsBanner' &&
                  <GenericAwardsBannerComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericCtaBannerWithmultipleLayout' &&
                  <GenericCtaBannerWithMultipleLayoutComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_TextComponentWithThumbImages' &&
                  <TextComponentWithThumbImagesComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FullWidthTestimonialModule' &&
                  <FullWidthTestimonialModuleComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_AllRelatedResources' &&
                  <AllRelatedResourcesComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_LogosGallery' &&
                  <LogosGalleryComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FaqAccordionComponent' &&
                  <FaqAccordionComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FullWidthTestimonialModuleCarouselNewModule2023' &&
                  <FullWidthTestimonialCarouselComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_NextCmoFullBannerSection' &&
                  <NextCmoFullBannerSectionComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_SolutionExchangeModule' &&
                  <SolutionExchangeComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericFiftyFiftySectionWithSmileyIconAndContent' &&
                  <SmileyIconAndContentComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_ProductPageFlexibleFields' &&
                  <ProductPageComponent data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_HalfAndHalfWithMarketo' &&
                  <HalfHalfMarketocomponent graphData={graphData} data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_EbookComponent' &&
                  <Ebookcomponent graphData={graphData} data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_MetricsSectionComponent' &&
                  <MetricSectioncomponent graphData={graphData} data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_QuoteCarouselSection' &&
                  <QuoteCarouselSection graphData={graphData} data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_FeaturedSolutionsComponent' &&
                  <FeaturedSolutionsComponent graphData={graphData} data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_GenericMultipleTabBasedComponentLatest2025' &&
                  <GenericMultipleTabBasedComponent graphData={graphData} data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
                {modularItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_CheckboxTableFormatComponent' &&
                  <CheckBoxTableFormatComponent graphData={graphData} data={modularItem} indItem={data.allWordpressPage.edges[0]} />
                }
              </React.Fragment>
            ))}
          </div>
        </div>
      }
    </Layout>
  );
}

export default Page;